import config from '../../config/config';

import getRequest from './base/get';
import postRequest from './base/post';

export default {
  /**
   * Fetch platform level data
   * @returns {any} A promise resolving to the platform level data
   */
  fetchPlatformLevel: (): Promise<any> => {
    return getRequest(`${config.emsp.emspApiUrl}api/v1/settings`);
  },
  /**
   * Create a new account level
   * @param {any} data - The data for the new account level
   * @returns {any} A promise resolving to the created account level
   */
  createAccountLevel: (data: any): Promise<any> => {
    const parameters = { ...data };
    return postRequest(
      `${config.subscription.accountApiUrl}api/super-admin/v1/facility-account/settings`,
      parameters,
    );
  },
  /**
   * Update platform level data
   * @param {any} data - The data to update the platform level
   * @returns {any} A promise resolving to the updated platform level
   */
  updatePlatformLevel: (data: any): Promise<any> => {
    const parameters = { ...data };
    return postRequest(`${config.emsp.emspApiUrl}api/v1/settings`, parameters);
  },
};
